import React from "react";
import { Paper, Typography, Grid, IconButton } from "@material-ui/core";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  title: {
    marginBottom: theme.spacing(1)
  },
  dataRow: {
    marginBottom: theme.spacing(1)
  }
}));
const PaperRecibo = ({ infoContract, generateReciboPdf}) => {
  const classes = useStyles();

  const handleOnCLick = async () => {
    const pdfUrl = await generateReciboPdf(infoContract);
    window.open(pdfUrl, "_blank");
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant="h5" className={classes.title}>
        Recibo de Contrato
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.dataRow}>
            Número de contrato: {infoContract.contrato.NUMCONTRATO}
          </Typography>
          <Typography className={classes.dataRow}>
            Monto total: ${infoContract.infoContrato.pcostoTotal}
          </Typography>
          <Typography className={classes.dataRow}>
            Superficie total: {infoContract.infoContrato.psuperficieTotal} m²
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.dataRow}>
            Mensualidades: {infoContract.infoContrato.pmensualidades}
          </Typography>
          <Typography className={classes.dataRow}>
            Monto de la mensualidad: $
            {Number(infoContract.infoContrato.pmontoMensualidad).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
      <IconButton color="primary" onClick={handleOnCLick}>
        <PictureAsPdfIcon />
      </IconButton>
    </Paper>
  );
};

export default PaperRecibo;
